module.exports = __webpack_public_path__ + "static/img/sy_zn.1a7432e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/sy_zn.png
// module id = /IIs
// module chunks = 1